// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1Rkn9","colCheckbox":"styles_colCheckbox__3JaXi"};